<template>
    <div style="background-color: #f2f2f2;height: 100%;" class="goodsClass">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            商品分类
        </div>
        <div style="padding: 20px;">
            <div>
                <el-row>
                    <el-button type="primary" plain @click.native="toggleModalAdd">添加</el-button>
                    <el-button style="padding:9px">
                        <el-checkbox style="margin:0 10px;" v-model="checked" @change="getData">只显示正常分类</el-checkbox>
                    </el-button>
                </el-row>

                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableDatas" :height="th" border style="width: 100%;"
                    row-key="goodsClassCode"
                    :row-class-name="tableRowClassName"
                    :tree-props="{children: 'secondGoodsClassList'}">
                        <el-table-column prop="name" label="名称"></el-table-column>
                        <el-table-column prop="icon" label="图标">
                            <template slot-scope="scope">
                                <el-popover placement="right" title="" trigger="click">
                                    <img :src="imgUrl+scope.row.icon"  style="width: 500px"/>
                                    <img slot="reference" :src="imgUrl+scope.row.icon" style="width:50px">
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column prop="sort" label="排序"></el-table-column>
                        <el-table-column prop="status" label="状态" align='center'>
                            <template slot-scope="scope">
                                <el-popover
                                    placement="right"
                                    width="160"
                                    title="提示"
                                    trigger="hover">
                                    <p>{{scope.row.status==1?'是否禁用此分类?':'是否启用此分类?'}}</p>
                                    <div style="text-align: center; margin: 0">
                                        <!-- <el-button type="primary" size="mini" @click="updataStatus(scope.row)">取消</el-button> -->
                                        <el-button type="primary" size="mini" @click="updataStatus(scope.row)">确定</el-button>
                                    </div>
                                    <el-tag type="success" slot="reference" v-if="scope.row.status==1">正常</el-tag>
                                    <el-tag type="danger" slot="reference" v-if="scope.row.status==2">禁用</el-tag>
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" width="200" align='center'>
                            <template slot-scope="scope">
                                <el-button type="primary" v-show="scope.row.parentGoodsClassCode=='00000000-0000-0000-0000-000000000000'" :disabled='scope.row.status==2' size="mini" @click="handleAdd(scope.row.goodsClassCode)">添加</el-button>
                                <el-button type="success" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-bind:attributeList="attributeList" v-on:closeAdd="closeAdd"  v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-bind:attributeList="attributeList" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import Edit from "./Edit";
    import Add from "./Add";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,
                checked:false,
                showModalAdd:false,
                showModalEdit:false,
                tableData:[],
                tableDatas:[],
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                name:'',
                status:1,
                attributeList:[],
                statusValue:[[1,'正常'],[2,'禁用']],
                imgUrl:this.$imgUrl,
            }
        },
        components:{
            Add,Edit
        },
        created(){
            this.init()
            this.getList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            init(){
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"GoodsAttribute/List",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.attributeList = response.data.data;
                    }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            handleEdit(index, row) {
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            handleAdd(data){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init(data);
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init('00000000-0000-0000-0000-000000000000');
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            updataStatus(row){
                var editForm={
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                    staffCode:getStaffCode(),
                }
                var list=[]
                for(var i in row.goodsAttributeList){
                    list.push(row.goodsAttributeList[i].goodsAttributeCode)
                }
                Object.assign(editForm, row);
                editForm.goodsAttributeCodeList=list
                editForm.status==1?editForm.status=2:editForm.status=1
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"GoodsClass/Edit",
                    data: editForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.getList();
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

            getList(isSearch){
                if(isSearch)this.currentPage=1
                
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"GoodsClass/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.tableData = response.data.data;
                        this.getData()
                    }else if(response.data.error == 1){
                        this.$message.error(response.data.message)
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            tableRowClassName({row}) {
                if (row.status == 2) {
                    return 'success-row';
                }
                return '';
            },
            getData(){
                var data=[]
                if(!this.checked){
                    data=this.tableData
                }else{
                    var listData=JSON.parse(JSON.stringify(this.tableData))
                    listData.forEach(val=>{
                        if(val.status==1){
                            var list=val
                            if(val.secondGoodsClassList.length>0){
                                var list1=[]
                                val.secondGoodsClassList.forEach(val1=>{
                                    if(val1.status==1){
                                        list1.push(val1)
                                    }
                                })
                                list.secondGoodsClassList=list1
                            }
                            data.push(list)
                        }
                    })
                }
                this.tableDatas=data
            },
            statusTitle(row){
                if(row.status == 1){
                    return "正常";
                }
                if(row.status == 2){
                    return "禁用";
                }
                return "其它";
            },



        }
    }
</script>

<style lang="scss" scoped>
    .goodsClass{
        /deep/ .el-table .cell .el-table__indent{
            padding-left: 50px !important;
        }
        /deep/ .el-table .success-row {
            background:#EBEEF5;
        }
    } 
    
</style>
